import {Component} from '@angular/core';
import { Validators} from "@angular/forms";
import {User, UserStatus} from "../interfaces/user";
import {BSValidators} from "../shared/bsvalidators";
import {LoginComponent} from "../login/login.component";

@Component({
    selector: 'bst-register',
    templateUrl: './register.component.html',
    styleUrls: ['../login/login.component.scss'],
    standalone: false
})
export class RegisterComponent extends LoginComponent {
  public regular: boolean = false;

  UserStatus = UserStatus;

  ngOnInit(): void {
    this.subs.push(this.route.queryParamMap.subscribe(async (queryParamMap) => {

      if(queryParamMap.has('with')){
        await this.invitedWith(queryParamMap.get('with'),
          queryParamMap.has('error') ? queryParamMap.get('error') : null);
      }
      else if(queryParamMap.has('error')){
        this.errorToast(queryParamMap.get('error'));
      }
      else{
        // Clean user

      }

      this.form = this.fb.group({
        with: [this.id],
        // name_first: [this.user ? this.user.name_first : null, [Validators.required]],
        // name_last: [this.user ? this.user.name_last : null, [Validators.required]],
        username: [{value: this.user ? this.user.username: null, disabled:this.user}, [Validators.required, BSValidators.email]],
        password: [null, [BSValidators.required]],
        // password_confirmation: [null, [Validators.required]]
      }, {});
    }));
  }

  async submit() {
    if(!this.submitting) {
      this.submitting = true;
      const formData = this.form.getRawValue();
      const did: User = await this.auth.register(formData);
      if (did) {
        if(this.itoast){
          this.itoast.close();
        }

        await this.registerToast();
        await this.entry();
      }
      this.submitting = false;
    }
  }

  private async registerToast(){
    const info = await this.translate.get(['registeredin', 'success']).toPromise();
    this.toast.success(info.registeredin, info.success, {
      duration: 3500,
      icon: 'checkmark'
    });
  }

  regularLogin() {
    this.regular = !this.regular;
  }

}
